export default {
  DELIVERY: 'delivery',
  PICK_UP: 'pickup'
}